import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
Vue.use(Vuetify);
// c75000
var THEME_LIGHT = {
  primary: '#3303FF',
  secondary: '#2000A7',
  accent: '#d0dcff',
  error: '#E51A3B',
  success: '#00D884',
  warning: '#FB8C00'
};
export default new Vuetify({
  dark: localStorage.getItem('meLembreTemaEscuro') === 'true',
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: THEME_LIGHT
    }
  }
});